export default "__VITE_ASSET__BMO804XF__"